import React from "react";

import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Divider, Paper } from "@mui/material";
import MenuMessages from "./MenuListMessages";
import MessagePanelOpenCard from "./MessagePanelOpenCard";
import NotificationPanelOpenCard from "./NotificationPanelOpenCard";
import NotificationListSignalIR from "./NotificationListSignalIR";
import NotificationPanelOpenCardSignalIR from "./NotificationPanelOpenCardSignalIR";
const NotificationDropdownSignalIR = ({ anchorEl, notificationUnreadCount,setNotificationMenu, setOpenNotificationPanel,t , allNotifications ,allNotificacoesNotRead , onMarkAllAsRead}) => {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
 
  const handleClose = () => {
    setNotificationMenu(null);
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Paper sx={{ p: 2 }}>
        <Typography variant="body1" fontWeight={"bold"}>
          {t("notifications")}
        </Typography>
        <Divider />
        <NotificationListSignalIR allNotificacoesNotRead={allNotificacoesNotRead}/>
        <NotificationPanelOpenCardSignalIR notificationUnreadCount={notificationUnreadCount} setOpenNotificationPanel={setOpenNotificationPanel} setNotificationMenu={setNotificationMenu} t={t} allNotifications={allNotifications} onMarkAllAsRead={onMarkAllAsRead} />
      </Paper>
    </Popover>
  );
};

export default NotificationDropdownSignalIR;
